import React, {Component} from 'react';
import {Redirect} from 'react-router';

import {Link} from 'components/ReactRouterDomLocalized';
import Registry from 'registry';

import {Form, InputWrapper} from 'form';
import {t} from 'l10n';
import {registerUser} from 'backend-helpers/member';
import SubmitWrapper from 'components/form/SubmitWrapper';
import GenderSelect from 'components/common/GenderSelect';

export default class ModalMenuSignupForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pending: false,
            done: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        // console.log(formData);

        this.setState({pending: true});

        registerUser(formData)
            .then((response) => {
                this.props.onRegisterSuccess(response);
                this.setState({done: true});
            })
            .catch((error) => {
                this.setState({pending: false});
                setErrors(error.messages || error.message, true);
            });
    }

    render() {
        if (this.state.done) return <Redirect to="/?confirm_registration"/>;

        let debug_nick, debug_email, debug_password;

        if(Registry.get('DEBUG_FORMS', false)) {
            debug_nick = 'bobweb' + Math.floor(Math.random() * 1000);
            debug_email = "bobvoyeurweb+" + debug_nick + "@gmail.com";
            debug_password = "passe";
        }

        return (
            <div>
                <p className="name">
                    <span>{t('Sign up')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>
                <Form onSubmit={this.onSubmit}>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="nick" type="text" placeholder={t('Nick')} defaultValue={debug_nick} />
                    </div>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="email" type="email" placeholder="Email" defaultValue={debug_email} forceHtml/>
                    </div>
                    <div className="space-between">
                        <GenderSelect name="gender" />
                    </div>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="password" type="password" placeholder={t('Password')} defaultValue={debug_password} />
                    </div>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="password_confirm" type="password" placeholder={t('Confirm password')} defaultValue={debug_password} />
                    </div>
                    <div>
                        <SubmitWrapper className="btn-submit" value={t('Enter')} pending={this.state.pending}/>
                    </div>
                </Form>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuSignupForm.js